module.exports = __webpack_public_path__ + "img/mgHotM.1188df8e.webp";